import DemoBadge from '@/components/feature/DemoBadge';

export default function RevenueHero() {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-14 md:pb-20 px-4 md:px-8 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20wide%20editorial%20illustration%20of%20a%20golf%20course%20merging%20into%20financial%20growth%20chart%20bars%20and%20map%20pins%20across%20two%20states%2C%20deep%20forest%20green%20and%20warm%20tan%20palette%20with%20a%20bold%20yellow-green%20highlight%2C%20dark%20cinematic%20edges%20for%20text%20contrast%2C%20clean%20modern%20geometric%20style%2C%20no%20text%20no%20people%20no%20logos&width=1920&height=1080&seq=gs-revenue-hero&orientation=landscape"
        alt="Stylized golf course and revenue growth illustration"
        title="GreenSide News revenue automation concept"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/75 to-foreground-950/45"></div>
      <div className="relative">
        <div className="flex flex-wrap items-center gap-3">
          <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">Revenue &amp; expansion demo</p>
          <DemoBadge label="Concept preview" tone="dark" />
        </div>
        <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-4xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tight mt-2 max-w-5xl">
          One platform. Many markets. Real revenue.
        </h1>
        <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
          A walk-through of how GreenSide News could sell sponsorships, monetise tournaments and publish across multiple regions &mdash; all from one central platform.
        </p>
        <div className="gs-rise-3 mt-7 inline-flex items-start gap-2.5 bg-accent-500 text-foreground-950 font-label font-bold uppercase tracking-widest text-[11px] md:text-xs px-4 py-3 rounded-md max-w-xl">
          <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0"><i className="ri-alert-line"></i></span>
          Conceptual Revenue Demo &mdash; No Real Payments, Registrations, or Automated Campaigns
        </div>
      </div>
    </section>
  );
}